import { useState } from "react";
import { motion } from "framer-motion";
import { Sticky } from "./NoteBlocks";

const fmt = (n) => (Number.isFinite(n) ? n.toLocaleString("en-IN", { maximumFractionDigits: 2 }) : "—");

const Field = ({ label, value, onChange, id, suffix }) => (
  <label className="block" htmlFor={id}>
    <span className="font-hand text-lg text-[#1F2A44]">{label}</span>
    <div className="calc-input">
      {!suffix && <span className="text-[#4A4A55]">₹</span>}
      <input id={id} type="number" min="0" value={value} onChange={(e) => onChange(e.target.value)} data-testid={`calc-input-${id}`} />
      {suffix && <span className="text-[#4A4A55]">{suffix}</span>}
    </div>
  </label>
);

const Result = ({ k, v, note, testId }) => (
  <div className="calc-result" data-testid={testId}>
    <p className="text-xs uppercase tracking-[0.2em] text-[#4A4A55]">{k}</p>
    <motion.p key={v} initial={{ y: 8, opacity: 0 }} animate={{ y: 0, opacity: 1 }} className="font-display text-5xl text-[#1F2A44] leading-none mt-2">{v}</motion.p>
    <p className="font-hand text-[15px] text-[#2B59C3] mt-1">{note}</p>
  </div>
);

export const Calculator = () => {
  const [spend, setSpend] = useState("10000");
  const [revenue, setRevenue] = useState("50000");
  const [orders, setOrders] = useState("40");
  const [margin, setMargin] = useState("40");
  const s = +spend, r = +revenue, o = +orders, m = +margin / 100;
  const roas = s ? r / s : NaN;
  const be = m ? 1 / m : NaN;
  const profit = r * m - s;
  const ok = Number.isFinite(roas) && Number.isFinite(be) && roas >= be;

  return (
    <div className="grid lg:grid-cols-[1fr_1.15fr] gap-8 items-start" data-testid="roas-calculator">
      <div className="notebook-card p-6 sm:p-8 grid gap-5">
        <Field id="spend" label="Ad spend" value={spend} onChange={setSpend} />
        <Field id="revenue" label="Revenue from ads" value={revenue} onChange={setRevenue} />
        <Field id="orders" label="Orders" value={orders} onChange={setOrders} suffix="orders" />
        <Field id="margin" label="Gross margin" value={margin} onChange={setMargin} suffix="%" />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <Result testId="calc-roas" k="ROAS" v={`${fmt(roas)}x`} note="revenue ÷ spend" />
        <Result testId="calc-cpa" k="CPA" v={`₹${fmt(o ? s / o : NaN)}`} note="spend ÷ orders" />
        <Result testId="calc-aov" k="AOV" v={`₹${fmt(o ? r / o : NaN)}`} note="revenue ÷ orders" />
        <Result testId="calc-be-roas" k="Break-even ROAS" v={`${fmt(be)}x`} note="1 ÷ margin" />
        <Sticky color={ok ? "green" : "pink"} rotate={-1} className="col-span-2" testId="calc-verdict">
          <p className="font-hand text-2xl">{ok ? "Profitable on ads ✓" : "Losing money on ads ✗"}</p>
          <p className="text-[15px] mt-1">
            Gross profit after ad spend ≈ <b>₹{fmt(profit)}</b>. {ok ? "Ab scaling socho." : "ROAS break-even se neeche hai — CPA kam karo ya AOV badhao."}
          </p>
        </Sticky>
      </div>
    </div>
  );
};
